import { CartUpdateEvent } from '@mockly/events';

class ComponentCartCount extends HTMLElement {
  constructor() {
    super();

    this.el = this;
    this.count = this.el.textContent ?? 0;

    this.handleCartUpdate = this.handleCartUpdate.bind(this);
  }

  handleCartUpdate(event) {
    this.count = event.cart?.item_count ?? 0;
    this.el.textContent = this.count;
  }

  connectedCallback() {
    window.addEventListener(CartUpdateEvent.eventName, this.handleCartUpdate);
  }

  disconnectedCallback() {
    window.removeEventListener(CartUpdateEvent.eventName, this.handleCartUpdate);
  }
}

if (!customElements.get('component-cart-count')) {
  customElements.define('component-cart-count', ComponentCartCount);
}